/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Feature3Inputs */

const ja_playdata_pricing_feature3 = /** @type {(inputs: Playdata_Pricing_Feature3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間帯別の同時視聴者数`)
};

const en_playdata_pricing_feature3 = /** @type {(inputs: Playdata_Pricing_Feature3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concurrent viewers by time of day`)
};

/**
* | output |
* | --- |
* | "Concurrent viewers by time of day" |
*
* @param {Playdata_Pricing_Feature3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_feature3 = /** @type {((inputs?: Playdata_Pricing_Feature3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Feature3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_feature3(inputs)
	return en_playdata_pricing_feature3(inputs)
});